export default {
    url: '/templates',
    template: '<div class="col00"><ui-view></ui-view></div>',
    abstract: true
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/templates/index.js